import flatten from 'lodash/flatten';
import { searchCategories } from 'shared/constants/searchCategories';

export const flattenIndustries = (industries, isSearchable = false) =>
  industries
    ? flatten(
        industries.map(({ sectors, code: industryCode, name: industryName }) =>
          sectors.map(({ code, name }) => ({
            code,
            name,
            industryCode,
            industryName,
            ...(isSearchable
              ? { category: searchCategories.INDUSTRY, group: industryName, value: code }
              : {}),
          })),
        ),
      )
    : [];
